export default __webpack_public_path__ + "assets/png/6fa725332c9b1bddfe3bb1439ab80aac.png";